import { useState } from 'react';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import FormModalContainer from '../../../../components/Modals/FormModalContainer';
import OfoqThemeBtn from '../../../../components/Buttons/OfoqThemeBtn';
import UseTranslation from '../../../../hooks/UseTranslation';

const ModulesWithHover = ({ roles, moduleName }) => {
  const [modulesModalStatus, setModulesModalStatus] = useState(false)
  const { t } = UseTranslation()

  return (
    <Box sx={styles.root}>
      {
        roles?.length > 0 ? (
          <Typography
            variant='body1'>{roles[0]}{' '}{roles[1] ? `, ${roles[1]}` : ''}</Typography>
        ) : '---'}

      {
        roles?.length > 2 && (
          <Box sx={styles.moreContainer}>
            <Box sx={styles.moreBInfo} onClick={() => setModulesModalStatus(true)}>+{+`${roles?.length}` - 2} {t?.more}</Box>
          </Box>
        )
      }

      <FormModalContainer
        modalState={modulesModalStatus}
        modalTitle={`${t?.['Roles for']} ${moduleName} (${roles?.length} ${t?.roles})`}
        customStyle={styles.modalCustomStyle}
        handleClose={() => setModulesModalStatus(false)}>
        <Box sx={styles.modulesListContainer}>
          {roles?.map((singleModule) => (
            <Box sx={styles.singleModuleLi} key={singleModule.id}>{singleModule}</Box>
          ))}
        </Box>
        <OfoqThemeBtn onClick={() => setModulesModalStatus(false)}
        name={t?.close} customStyle={styles.closeBtn} />
      </FormModalContainer>
    </Box>
  )
}

const styles = {
  root: {
    display: 'flex',
    alignItems: 'baseline',
    '& p': {
      marginRight: '10px',
    },
  },
  moreBInfo: {
    color: 'primary.main',
    cursor: 'pointer',
    fontSize: { xs: '12px', sm: '14px' },
  },
  modalCustomStyle: {
    fontFamily: 'Avenir',
    fontSize: { xs: '14px', sm: '16px' },
    '& h6': {
      fontSize: { xs: '16px', sm: '20px' },

    },
  },
  modulesListContainer: {
    maxHeight: '300px',
    overflow: 'hidden',
    overflowY: 'hidden',
    marginBottom: '20px',
    display: 'block',

    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 0 grey',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#29cc8b',
      borderRadius: '10px',
    },
    scrollbarColor: '#29cc8b transparent',
    scrollbarWidth: 'thin',
  },
  popupModulesCount: {
    color: '#a9a9a9',
    backgroundColor: '#f7f7f7',
    padding: '5px 15px',
    margin: { xs: '15px -15px 0', sm: '0 -15px' },
    marginBottom: '15px',
  },
  singleModuleLi: {
    padding: { xs: '5px 15px', sm: '10px 15px' },
    margin: '0 -15px',
    marginBottom: '5px',
    borderBottom: '1px solid #d7d7d7',
    textTransform: 'capitalize',
  },
  closeBtn: {
    marginLeft: 'auto',
    display: 'flex',
    marginTop: '10px',
    maxWidth: { xs: '100%', sm: '150px' },
    height: { xs: '40px', sm: '40px' },
  },
}

export default ModulesWithHover
